import { makeStyles } from "@material-ui/core";

export const useCommonStyles = makeStyles((theme) => ({
    dialog: {
        maxWidth: '690px'
    },
    divider: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        height: 2,
        background: '#EEE'
    },
    topContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12
    },
    content: {
        maxWidth: '690px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
    },
    subtitle: {
        color: 'rgba(26, 26, 26, 0.87)',
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '26px',
        letterSpacing: 0.3,
    },
    bottomContent: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    },
    dividerBottom: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(4),
        height: 2,
        background: "#EEE",
    },
}));